import React, { useRef, useState, useEffect } from 'react';
import { useUserMedia } from '../Hooks/useUserMedia';
import {Label, Header, Button, Grid} from 'semantic-ui-react'

import {v1 as uuid} from 'uuid'
import {useHistory,useParams, Route, Switch} from 'react-router-dom'
import SelectUserSize from './SelectUserSize'
import PaketKorrektur from './PaketKorrektur'
import useBarcode from './useBarcode'
import useOcr from './useOcr'
import checkCodes from './paketCodeCheck'
import dienste from './dienste'






const [xRes,yRes]=[500,500]







function ScanPaket({db}) {


  const {dienst}=useParams()

  const [scanningStep,setScanningStep]=useState()

  const captureOptions = {
    audio: false,
    video: scanningStep!=='ocr' && scanningStep!=='ocr-request'? dienste[dienst].capture : {
       facingMode: "environment", aspectRatio: { exact:1}, width: 780 
    }
  }

  const videoRef = useRef();
  const canvasRef = useRef()
  const history=useHistory()
   const [mediaStream,setMediaStream] = useUserMedia(videoRef,captureOptions);
  const [track,setTrack] = useState({})
  const [playing,setPlaying]=useState(false)
  const [korrektur,setKorrektur]=useState(false)
  const barcodeActive=useRef(false)

  const ocrActive=useRef(false)

  const [videoKey,setVideoKey]= useState(0)
  const mapCodes= dienste[dienst] ==='Info' ? true : false
  
  

  const newBrief= ()=>
  {
          const id=uuid()        
          const myPaket= {
              UID:id,
              Kunde:'',
              ShopId:'',
              Dienst:dienst,
              Datum:Date.now()/1000,
              AbsenderK:'',
              Paketnummer:'Brief: '+Date.now(),
              Status:'registriert',
              Size:'Brief'
  
          }
          db.pakete.add(myPaket)
          setActPaket(myPaket.UID)
 }



  if (mediaStream && videoRef.current && !videoRef.current.srcObject)
  {
   // videoRef.current.srcObject = mediaStream;
  }


// paketDienst,shopId,videoRef,barcodeActive,scanningStep,setScanningStep,pakete,setPakete, checkCode, mapCodes
  const [actPaket,setActPaket]=useBarcode(
    { 
        paketDienst: dienst,
        videoRef:videoRef,
        barcodeActive:barcodeActive,
        scanningStep: scanningStep,
        setScanningStep:setScanningStep,
        setMediaStream: setMediaStream,
        shopDB:db.shops,
        checkCode:checkCodes[dienst],
        mapCodes: mapCodes,
        paketeDB: db.pakete
      }
    )
  const [userDetected,setUserDetected]=useOcr(
    {
      videoRef:videoRef,
      ocrActive:ocrActive,
      scanningStep:scanningStep,
      setScanningStep:setScanningStep,
      setMediaStream: setMediaStream,
      usersDB:db.users,
      shopDB:db.shops,
      actPaket: actPaket,
      setKorrektur:setKorrektur,
      dienst: dienst


    }
  )


  useEffect(()=>
  {

    const getKunde= async ()=>
    {
       const paket = await db.pakete.get(actPaket)
       if(paket.Kunde)
       {
          const kunde =await db.users.get(paket.Kunde)
          setUserDetected([kunde])
          history.push(`/register/paket/${dienst}/select`)

       }
       else
       {
        history.push(`/register/paket/${dienst}/correct`)
       }
    }

    
    if(scanningStep && !barcodeActive.current && ! ocrActive.current && playing)
    {
      if(scanningStep==='barcode-request' )
      {
        setActPaket(null)
        barcodeActive.current=true // start scanning
              // switch on tourch light
        track.applyConstraints({
            advanced: [{torch: true}]
        })
        setScanningStep('barcode')
      }
      else if(scanningStep==='show-paket')
      {
         track.applyConstraints({
            advanced: [{torch: false}]
        })
        setScanningStep(null)
        if(actPaket)
        {
          getKunde()
        }
      }
      else if(scanningStep==='ocr-request' && ! mediaStream)
      {
        track.applyConstraints({
            advanced: [{torch: true}]
        })
         ocrActive.current=true
         setScanningStep('ocr')

      }
      else if(scanningStep==='completed' && userDetected.length)
      {
        track.applyConstraints({
            advanced: [{torch: false}]
        })
        setScanningStep(null)
        if(userDetected.length>1)
          history.push(`/register/paket/${dienst}/correct`)        
        else
          history.push(`/register/paket/${dienst}/select`)

      }
    }
    else if((!scanningStep ) && !barcodeActive && ! ocrActive)
    {
        track.applyConstraints({
            advanced: [{torch: false}]
        })

    }

  },[scanningStep,barcodeActive,ocrActive,actPaket,userDetected,playing,mediaStream])
  
  
  function handleCanPlay() {
    videoRef.current.play();
    setPlaying(true)
    setTrack(mediaStream.getVideoTracks()[0])
  }

  const handleCapture= async () =>
  {
    const context = canvasRef.current.getContext("2d");
    context.drawImage(videoRef.current, 0, 0, xRes, yRes, 0, 0, xRes, yRes);

  // (Optional) A series of barcode formats to search for.
  // Not all formats may be supported on all platforms
 
   
    //const { data: { text } } = await tWorker.current.recognize(canvasRef.current);
    //console.log(text);
  }

 

  const getBoderStyle=()=>
  {
    const display= scanningStep!=='completed' || null ? 'initial' : 'none' 
    if(scanningStep==='barcode' && barcodeActive.current)
      return {border:'solid blue 5px',display:display, marginLeft: '30px' }
    if(scanningStep==='ocr' && ocrActive.current)
      return {border:'solid yellow 5px',display: display, marginLeft: '30px'}
    if(scanningStep==='completed' && ocrActive.current)
      return {border:'solid green 5px',display: display, marginLeft: '30px'}
    return {border:'solid red 5px',display: display, marginLeft: '30px' }

  }

  const click= async (e)=>
  {
    window.navigator.vibrate([100,100,100]);
   
    if(scanningStep==='barcode') 
    {
      barcodeActive.current=false
      setScanningStep(null)
      track.applyConstraints({
        advanced: [{torch: false}]
      })
    
    }
    else if (scanningStep==='ocr')
    {
      ocrActive.current=false
      setScanningStep(null)
      history.push(`/register/paket/${dienst}/correct`)
    }
  
 
  }


  const manuell= async (e)=>
  {
      if(!scanningStep && dienst !=='Brief' )
      {
        // start  barcode scanning
 
          setScanningStep('barcode-request')
      }
     if(scanningStep==='barcode' || (!scanningStep && dienst==='Brief')) 
     {
        const shop= await db.shops.get('MyShop')
        if(!shop)
        {
          alert('Synchronisation läuft noch, später nochmals probieren')
          barcodeActive.current=false
          setScanningStep(null)
        }
        else
        {
          const deviceId=localStorage.getItem('DeviceId')
          const device=await db.devices.get(deviceId)

          const devicePrefix=device.Prefix
          const deviceNextCode=parseInt(device.NextCode)
          window.navigator.vibrate([200]);        
          const myPaket= {
              UID:uuid(),
              Kunde:'',
              ShopId:'',
              Dienst:dienst,
              Datum:Date.now()/1000,
              AbsenderK:'',
              Paketnummer:devicePrefix+ deviceNextCode,
              Status:'zugeordnet'
          }
          await db.pakete.add(myPaket)
          await db.devices.update(deviceId,{NextCode:deviceNextCode+1})
          setActPaket(myPaket.UID)
          barcodeActive.current=false
          setMediaStream(null)
          setScanningStep('ocr-request')
        }

     }
     if (scanningStep==='ocr')
     {
       ocrActive.current=false
       setScanningStep(null)
       track.applyConstraints({
           advanced: [{torch: false}]
       })
       history.push(`/register/paket/${dienst}/correct`)
     }

  }
  useEffect(()=>
  {
    if(history.location.pathname.includes('scan'))
    {
      setVideoKey(key=>++key)
      setMediaStream(null)
    }
  },[history.location.pathname])
  



  return (
  <>

     <Switch>
        <Route path={'/register/paket/:Dienst/scan'} >

              <Grid style={{marginTop:'3px', marginBottom:'10px'}} >
                <Grid.Column width={6} key={1}>
                  {
                    !scanningStep ? '' :
                    <Button content='stop' onClick={click}/>
                  }
                </Grid.Column>
                <Grid.Column width={10} key={2}>
                  <Header as="h2">Scan <Label color={dienste[dienst].color}>{dienste[dienst].name}</Label></Header> 
                </Grid.Column>
              </Grid>
              <video 
                  ref={videoRef} 
                  onCanPlayThrough={handleCanPlay} 
                  width="320" 
                  onClick={manuell} 
                  style={getBoderStyle()}
                  autoPlay 
                  playsInline
                  muted 
                  key={videoKey}

                />
        </Route>
        <Route exact path={'/register/paket/:Dienst/select'}>

            <SelectUserSize 
              kunden={userDetected}
              setKunden={setUserDetected}
              paketUID={actPaket}
              paketeDB={db.pakete}
              korrektur={korrektur}
              setKorrektur={setKorrektur}
              setScanningStep={setScanningStep}
              dienst={dienst}

            />
        </Route>
        <Route path={'/register/paket/:Dienst/correct'}>

            <PaketKorrektur
              kunden={userDetected}
              setKunden={setUserDetected}
              paketeDB={db.pakete}
              db={db}
              dienst={dienst}
              korrektur={korrektur}
              setKorrektur={setKorrektur}
              paketUID={actPaket}

            />
          </Route>
        </Switch>

  </>
  );
}

export default ScanPaket
